import AttachmentDataProvider from 'owa-service/lib/contract/AttachmentDataProvider';
import getAllAttachmentDataProvidersOperation from 'owa-service/lib/operation/getAllAttachmentDataProvidersOperation';
import getAttachmentDataProvidersRequest from 'owa-service/lib/factory/getAttachmentDataProvidersRequest';
import RequestOriginType from 'owa-service/lib/contract/RequestOriginType';

// Get the Attachment Data providers that the user can load files from
export default function getAttachmentDataProviders(
    requestOriginType: RequestOriginType = RequestOriginType.FilePicker
): Promise<AttachmentDataProvider[]> {
    const request = getAttachmentDataProvidersRequest({
        ClientVersion: 2,
        RequestOrigin: requestOriginType,
    });

    return getAllAttachmentDataProvidersOperation(request);
}
